/**
 * The request an edited scrapbook post makes. The words only, never the pictures.
 *
 * WHY IT LIVES IN ITS OWN FILE
 * ----------------------------
 * It is a pure function with no imports, so a test can reach it directly. Every
 * component that uses it mocks `store/slices/api` wholesale — it has to, because
 * pulling in the real RTK Query module chain is more than Jest will parse — and
 * that mock would leave this line unexercised. It was: a mutation on 2026-09-20
 * that sent the whole post object, id and all, survived the entire suite.
 *
 * WHAT IT GUARANTEES
 * ------------------
 * postId addresses the row and does NOT travel in the body. The server refuses an
 * `attachments` key outright, because swapping the picture out from under comments
 * written about it would silently make those replies be about something nobody
 * agreed to — so a caller that shovels a whole post object at this endpoint would
 * be refused, and confusingly.
 */
export function scrapbookEditRequest({ postId, ...body }) {
  return { url: `scrapbook/post/${postId}`, method: "PUT", body };
}

export default scrapbookEditRequest;
